<template>
  <div justify="center">
    <v-snackbar v-model="snackbar" :timeout="2000">
      คัดลอกเรียบร้อย
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
    <v-card flat>
      <v-card-title class="pa-0 pt-4 pl-5">
        <span>Survey Info</span>
        <v-spacer></v-spacer>
        <v-switch
          v-model="surveyform.surveyStatus"
          :color="SPermission.enableControl ? '#033666' : 'grey'"
          :disabled="!SPermission.enableControl"
          @click.stop="ToggleSurvey()"
          class="mx-10"
          hide-details
          :label="switchText"
        ></v-switch>
      </v-card-title>
      <v-card-title class="pa-0 pt-2 pl-5 pb-4">
        <img src="../../assets/img/linemd.png" width="60px" />
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row no-gutters>
            <v-col cols="12" sm="2" class="mb-4">
              <v-subheader>Survey ID :</v-subheader>
            </v-col>
            <v-col cols="12" sm="10" class="d-flex mb-4">
              <span style="align-self: center; font-size: 16px; color: black">{{
                surveyform.surveyID
              }}</span>
              <v-btn
                color="#1184bd"
                icon
                class="ml-3"
                style="align-self: center"
                @click="
                  $store.getters.CopyText(surveyform.surveyID),
                    (snackbar = true)
                "
                ><v-icon>content_copy</v-icon></v-btn
              >
            </v-col>
            <v-col cols="12" sm="2">
              <v-subheader>ชื่อ Survey :</v-subheader>
            </v-col>
            <v-col cols="12" sm="10">
              <v-text-field
                color="#0D8EEE"
                outlined
                dense
                v-model="surveyform.surveyName"
                :disabled="!SPermission.update"
                :rules="[$store.getters.TextRule(surveyform.surveyName)]"
                counter="100"
                maxLength="100"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-subheader>รายละเอียด :</v-subheader>
            </v-col>
            <v-col cols="12" sm="10">
              <v-text-field
                color="#0D8EEE"
                outlined
                dense
                :disabled="!SPermission.update"
                v-model="surveyform.surveyDetail"
                counter="100"
                maxLength="100"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-subheader>รูปปก Survey :</v-subheader>
            </v-col>
            <v-col cols="12" sm="10">
              <v-card v-show="!surveyform.surveyCoverPic" class="pt-2" flat>
                <input
                  ref="coverimage"
                  type="file"
                  accept="image/*"
                  @change="CoverImage()"
                  class="d-none"
                />
                <v-btn
                  :disabled="!SPermission.update"
                  @click="$refs.coverimage.click()"
                >
                  <v-icon small class="mr-2">mdi-image</v-icon>
                  เลือกรูปภาพ
                </v-btn>
              </v-card>
              <v-card v-show="surveyform.surveyCoverPic" class="pt-2" flat>
                <v-card>
                  <v-card-title class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="#DE4F3B"
                      :disabled="!SPermission.update"
                      @click="surveyform.surveyCoverPic = ''"
                      ><v-icon>clear</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text class="d-flex justify-center">
                    <img :src="surveyform.surveyCoverPic" width="100" />
                  </v-card-text>
                  <v-card-text>
                    <v-btn
                      color="primary"
                      outlined
                      block
                      :disabled="!SPermission.update"
                      @click="$refs.coverimage.click()"
                      >เปลี่ยนรูป</v-btn
                    >
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  props: ["surveyform"],
  data: () => ({
    edit: false,
    snackbar: false,
  }),
  computed: {
    SPermission() {
      return this.$store.state.user_permission.survey;
    },
    switchText() {
      return this.surveyform.surveyStatus ? "เปิดแบบสอบถาม" : "ปิดแบบสอบถาม";
    },
  },
  methods: {
    ClearSpace() {
      this.surveyform.surveyName = this.surveyform.surveyName.replace(
        /\s/g,
        ""
      );
    },
    SpaceNotAllow(event) {
      if (event.key === " ") {
        event.preventDefault();
      }
    },
    CoverImage() {
      for (const key in this.$refs.coverimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.coverimage.files, key)) {
          const element = this.$refs.coverimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-cover/question/`
            );
            formData.append("fileName", `${Date.now()}-cover-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              vm.surveyform.surveyCoverPic = req.data;
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.coverimage.type = "text";
              this.$refs.coverimage.type = "file";
            });
          }
        }
      }
      this.$refs.coverimage.type = "text";
      this.$refs.coverimage.type = "file";
    },
    ToggleSurvey() {
      Swal.fire({
        title: `ยืนยันการ${
          !this.surveyform.surveyStatus ? "ปิด" : "เปิด"
        }แบบสอบถาม`,
        text: "",
        icon: "warning",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("UpdateSurveyStatus", this.surveyform)
            .then(() => {
              Swal.fire({
                icon: "success",
                text: `${
                  !this.surveyform.surveyStatus ? "ปิด" : "เปิด"
                }แบบสอบถามเรียบร้อยแล้ว`,
                title: "",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                if (
                  this.$route.params.surveyName !== this.surveyform.surveyName
                ) {
                  this.$router.push({
                    name: "setting",
                    params: {
                      surveyID: this.$route.params.surveyID,
                      surveyName: this.surveyform.surveyName,
                    },
                  });
                }
                this.$store.state.surveystatus = this.surveyform.surveyStatus;
                this.$store.dispatch("getSurvey");
                this.$emit("getSurveyByID");
              });
            })
            .catch((err) => {
              let errMsg =
                err.data.message === "Permission Denied"
                  ? "คุณไม่มีสิทธิ์เข้าถึงการเปิดหรือปิด survey"
                  : "ไม่สามารถแก้ไขได้";
              Swal.fire({
                icon: "error",
                text: errMsg,
                title: "",
              }).then(() => {
                this.$store.dispatch("getSurvey");
                this.$store.commit("ToggleLoading");
                if (err.data.message === "Permission Denied") {
                  this.$store
                    .dispatch(
                      "getQuestionPermission",
                      this.$route.params.surveyID
                    )
                    .then(() => {
                      this.$router.push({
                        name: "question",
                      });
                    });
                }
              });
            });
        } else {
          this.surveyform.surveyStatus = !this.surveyform.surveyStatus;
        }
      });
    },
  },
};
</script>
